export const HonestPricingLawServiceFeeTypes = {
  ONLINE_ORDER: 'online_order',
  GROUP_ORDER: 'group_order',
  DINE_IN_ORDER: 'dine_in_order',
  CATERING_ORDER: 'catering_order'
};

export const HONEST_PRICING_LAW_SERVICE_FEE_NAMES = {
  [HonestPricingLawServiceFeeTypes.ONLINE_ORDER]: 'Online Order Service Fee',
  [HonestPricingLawServiceFeeTypes.GROUP_ORDER]: 'Group Order Service Fee',
  [HonestPricingLawServiceFeeTypes.DINE_IN_ORDER]: 'Dine-In Order Service Fee',
  [HonestPricingLawServiceFeeTypes.CATERING_ORDER]: 'Catering Order Service Fee'
};
